import { render, staticRenderFns } from "./level2-sided.vue?vue&type=template&id=2d5c1366&"
import script from "./level2-sided.vue?vue&type=script&lang=js&"
export * from "./level2-sided.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports